export const ROLL_COLORS = [
	{ bg: "#dbeafe", border: "#3b82f6", text: "#1d4ed8", line: "#3b82f6" },
	{ bg: "#fef3c7", border: "#f59e0b", text: "#b45309", line: "#f59e0b" },
	{ bg: "#f3e8ff", border: "#a855f7", text: "#7c3aed", line: "#a855f7" },
	{ bg: "#fce7f3", border: "#ec4899", text: "#be185d", line: "#ec4899" },
	{ bg: "#d1fae5", border: "#10b981", text: "#047857", line: "#10b981" },
	{ bg: "#e0e7ff", border: "#6366f1", text: "#4338ca", line: "#6366f1" },
	{ bg: "#ffedd5", border: "#f97316", text: "#c2410c", line: "#f97316" },
	{ bg: "#cffafe", border: "#06b6d4", text: "#0e7490", line: "#06b6d4" },
];

export const ORPHAN_COLOR = {
	bg: "#fef3c7",
	border: "#d97706",
	text: "#b45309",
	line: "#d97706",
};
